import React from "react"
import "./styles.scss"
const CompanyAddress = ({ usaAddress, plAddress }) => {
  return (
    <section className="section section--address">
      <div className="wrapper--text">
        <div className="address__wrapper">
          <div className="address--usa">
            <div className="address__row">
              <h6>United States</h6>
              <h5>{usaAddress.addressTitle}</h5>
              <p
                dangerouslySetInnerHTML={{ __html: usaAddress.addressInfo }}
              ></p>
            </div>
            <div className="address__row">
              <h6>REGISTRATION NUMBER:</h6>
              <p>{usaAddress.registrationNumber}</p>
            </div>
            <div className="address__row">
              <h6>JURISDICTION OF FORMATION:</h6>
              <p>{usaAddress.jurisdictionOfFormation}</p>
            </div>
          </div>
          <div className="address--pl">
            <div className="address__row">
              <h6>EUROPE HEAD OFFICE</h6>
              <h5>{plAddress.addressTitle}</h5>
              <p
                dangerouslySetInnerHTML={{ __html: plAddress.addressInfo }}
              ></p>
            </div>
            <div className="address__row">
              <h6>EU VAT-ID:</h6>
              <p>{plAddress.euVatID}</p>
            </div>
            <div className="address__row">
              <h6>D-U-N-S® NUMBER:</h6>
              <p>{plAddress.dunsNumber}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CompanyAddress
